<template>
  <div class="findPassword">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
      <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  ></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>找回密码</h3></div>
    <div class="registerStepCon">
      <el-steps :active="0" align-center>
        <el-step title="1 基本信息"></el-step>
        <el-step title="2 验证身份"></el-step>
        <el-step title="3 重置密码"></el-step>
        <el-step title="4 操作完成"></el-step>
      </el-steps>
      <div class="baseInforConCon">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="输入用户名" prop="name">
            <el-input v-model="baseForm.name" :maxlength="50"></el-input>
            <span>若忘记邮箱/用户名，请联系您的企业管理员</span>
          </el-form-item>
          <el-form-item label="验证码" prop="yzm" class="verifyCon">
            <el-input v-model="baseForm.yzm" class="pull-left" @blur="checkVerifyCode()"></el-input>
            <img class="pull-left" id="verifyCode" :src="verrifyCodeUrl" alt="验证码出不来,请点击" @click="changeVerifyCode()">
            <a @click="changeVerifyCode()">看不清，换一张</a>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="goToHref('/verifyIdentity')">下一步</el-button>
    </div>
    
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  export default {
    props: [],
    data () {
      var checkUserName = (rule, value, callback) => {
        this.baseForm.name = value.trim();
        this.$axios.post('/onelink.mdata.main.api/user/existMemberInforByEmail?userEmail='+this.baseForm.name, {
        }).then((res) => {
          this.data = res.data;
          let checkResult =  this.data.data.updateFlag;
          if(!checkResult){
            return callback(new Error('用户名不存在，你可以重新注册或联系客服'));
          }else{
            this.userInfo =  this.data.data.userInfo;
            return callback();
          }
        }).catch((err) => {
          console.log(err)
        })
      };
      return {
        checkVerifyFlag:false,
        userInfo:{},
        navTitle:'找回密码',
        verrifyCodeUrl:'',
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        webConfigInfo: {},
        checkList:[],
        abroadShow:false,
        baseForm: {
          name: '',
          yzm: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { validator: checkUserName, trigger: 'blur' }

          ],
          yzm: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.verrifyCodeUrl = this.data.verrifyCodeUrl+"?operateType=complain_&?date=" + encodeURI(encodeURI(new Date()));
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      goToHref(val){
         this.$refs['baseForm'].validate((valid) => {
          if (valid) {
            if(!this.checkVerifyFlag){
              // var img = document.getElementById("verifyCode");
              // img.src = this.verrifyCodeUrl+"?date=" + encodeURI(new Date());
              this.$message({
                    message: "验证码输入错误",
                    type: 'error'
              });
              return false;
            }else{
              this.$router.push({path: val,query:{email:this.userInfo.email}})
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      changeVerifyCode(){
        var img = document.getElementById("verifyCode");
        img.src = this.verrifyCodeUrl+"?date=" + encodeURI(new Date());
        this.baseForm.yzm = "";
      },
      checkVerifyCode(){
        if(this.baseForm.yzm !=''){
          this.$axios.post('/onelink.mdata.main.api/kaptcha/verifyKaptcha?vrifyCode='+this.baseForm.yzm+"&operateType=complain_", {
          }).then((res) => {
            this.data = res.data;
            let checkFlag = this.data.data;
            if(!checkFlag){
              var img = document.getElementById("verifyCode");
              img.src = this.verrifyCodeUrl+"?date=" + encodeURI(new Date());
              this.$message({
                    message: "验证码输入错误",
                    type: 'error'
              });
              this.checkVerifyFlag = false;
            }else{
              this.checkVerifyFlag = true;
            }
          }).catch((err) => {
            console.log(err)
          })
        }
        
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/findPassword/index.vue